import { createAction } from 'redux-act';

import Hours from '../../../models/interfaces/Hours';
import FetchPayload from '../FetchPayload';
import TimestampPayload from '../TimestampPayload';

export interface FetchHoursPayload extends FetchPayload {
  placeUuid: string;
}
export const fetchHours = createAction<FetchHoursPayload>('FETCH_HOURS');

export interface HoursFetchedPayload extends TimestampPayload {
  hours: Hours;
}
export const hoursFetched = createAction<HoursFetchedPayload>('HOURS_FETCHED');

export interface HoursFetchFailedPayload extends TimestampPayload {
  placeUuid: string;
}
export const hoursFetchFailed = createAction<HoursFetchFailedPayload>('HOURS_FETCH_FAILED');

export type HoursFetchResponsePayload = HoursFetchedPayload | HoursFetchFailedPayload;
